/**
 * The product's display name: the ONE place it is written.
 *
 * Every surface that names the product — the shell, feature packages, the
 * design system's report creator, emails and service messages — imports this
 * constant instead of typing the name. A rename is an edit here plus a
 * redeploy. `scripts/check-product-name.mjs` fails a typed product name
 * anywhere else, and keeps the Keycloak theme's `brandName` and the shell's
 * `index.html` `<title>` equal to this value. Coding agents and AI prompts
 * follow the same rule (CLAUDE.md).
 */
export const PRODUCT_NAME = "Kaivera";
//# sourceMappingURL=brand.js.map